//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { AddIcon, Button, Select, Table, EditIcon } from '@gamesb42/ui-kit';

import baseRequest from 'queries/baseRequest';
import Status from 'components/common/Status';
import AddModal from './components/AddModal';
import EditModal from './components/EditModal';
import CompanySelect from 'components/CompanySelect';
import { updateTitle } from 'helpers/common';
import { getToken } from 'helpers/token';
import Flex from 'components/Flex';
import { getDocumentTypes } from 'api/docs';

import s from './styles.module.scss';

const columns = [
  {
    title: 'Document name',
    dataIndex: 'title',
  },
  {
    dataIndex: 'id',
    align: 'center' as const,
    width: '56px',
    noSkeleton: true,
    render: (id: string) => <Button className={s.edit} icon={<EditIcon />} type="iconBtn" />,
  },
];

export default function DocsDirectoryPage() {
  const [value1, setValue1] = useState();
  const [value2, setValue2] = useState();
  const [value3, setValue3] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [activeRecord, setActiveRecord] = useState({});

  const getData = async () => {
    return getDocumentTypes()
      .then((result) => {
        setData(result);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    updateTitle('Documents directory');
    getData();
  }, []);

  return (
    <>
      <div className={s.title}>
        <h1>Documents directory</h1>
        <Button icon={<AddIcon size={16} />} type="primary" onClick={() => setIsOpenAddModal(true)}>
          Add document type
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={data}
        className={s.table}
        rowClassName={s.row}
        onRow={(record) => ({
          onClick: () => {
            setActiveRecord(record);
            setIsOpenEditModal(true);
          },
        })}
      />

      {isOpenAddModal && (
        <AddModal
          onClose={() => {
            setIsOpenAddModal(false);
          }}
          getData={getData}
        />
      )}
      {isOpenEditModal && (
        <EditModal
          onClose={() => {
            setIsOpenEditModal(false);
          }}
          getData={getData}
          activeRecord={activeRecord}
        />
      )}
    </>
  );
}
